import { SHA256 } from "crypto-js";
import {
  CheckInUserPropertiesDto,
  CheckInVpvEventDto,
  CheckInVpvEventParamsDto,
  VpvEventInput,
} from "../dto/vpv.dto";

export const CheckInVpvEvent = (
  data: VpvEventInput
): CheckInVpvEventDto => {
  const {
    micrositio,
    page_path,
    page_type,
    page_title,
    homemarket,
    environment,
    login,
    user_props = {},
  } = data;

  const event_params = new CheckInVpvEventParamsDto();
  event_params.micrositio = micrositio;
  event_params.page_path = page_path;
  event_params.page_type = page_type;
  event_params.page_title = page_title;
  event_params.homemarket = homemarket;
  event_params.environment = environment;
  event_params.login = login;

  const dto = new CheckInVpvEventDto();
  dto.event = "vpv";
  dto.event_params = event_params;

  // verify user props
  if (user_props && user_props.pas_dni) {
    const user_properties = new CheckInUserPropertiesDto();
    user_properties.pas_dni_hashed = SHA256(user_props.pas_dni).toString();
    if (user_props.birthday) {
      user_properties.birthday = user_props.birthday;
    }
    user_properties.user_type = user_props.user_type || "guest";

    dto.user_properties = user_properties;
  }

  return dto;
};
